import '@babel/polyfill'
import Vue from 'vue'
import index from './index.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import qs from 'qs'
import VueAwesomeSwiper from 'vue-awesome-swiper'
//微信登陆配置。
import wechatAuth from './wechatAuth' //微信登录插件
import QRCode from 'qrcode' //定义生成二维码组件
Vue.use(wechatAuth, {
	appid: 'wx8197e238566b4f1d'
});
import $ from 'jquery'

// import BaiduMap from 'vue-baidu-map'
////倒计时
import { CountDown } from 'vant';
Vue.use(CountDown);

import iView from 'iview';
import 'iview/dist/styles/iview.css';    // 使用 CSS
Vue.use(iView);
import Storage from './storage'; // 引入封装的storage.js
 
Vue.prototype.$storage = Storage; // 挂载到Vue原型上

// Vue.use(BaiduMap, {
// 	/* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
// 	ak: 'PlhFWpA02aoURjAOpnWcRGqw7AI8EEyO'
// });
//import Loading from '@/components/loading'
//Vue.use(Loading)
import Cookies from 'js-cookie'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
//////////////////////
import 'amfe-flexible'
//import './assets/stylus/reset.styl'
Vue.config.productionTip = false
var VueTouch = require('vue-touch')
Vue.use(VueTouch, {
	name: 'v-touch'
})
///////////////新闻
// import VueQuillEditor, { Quill } from 'vue-quill-editor'
//import { ImageDrop } from 'quill-image-drop-module'
//import ImageResize from 'quill-image-resize-module'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
//Quill.register('modules/imageDrop', ImageDrop)
//Quill.register('modules/imageResize', ImageResize)
// Vue.use(VueQuillEditor)
//////////////
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)
////////////////////////
//axios.defaults.timeout = 5000; // 在超时前，所有请求都会等待 5 秒
//axios.defaults.headers.post['Content-Type']= application/x-www-form-urlencoded;charset='UTF-8';// 配置请求头
//axios.defaults.baseURL = 'http://d.clfx.sctjsj.com'; // 配置接口地址
//axios.defaults.baseURL = 'https://www.dongshanhaibao.com'; // 配置接口地址
//axios.defaults.baseURL = 'https://api.51jincai.com'; // 配置接口地址
axios.defaults.withCredentials = true; //意思是携带cookie信息,保持session的一致性
Vue.prototype.$axios = axios
import 'swiper/dist/css/swiper.css'
import wx from 'weixin-js-sdk';
import { server } from './request/axios'
import { MessageBox } from 'element-ui';
//定义全局变量
Vue.prototype.$server = server;
//数据统计
import webStatistics from '@/js/webStatistics.js'
Vue.prototype.webStatistics = webStatistics;
Vue.use(webStatistics);

import configId from '@/js/configId.js'
Vue.prototype.configId = configId;
Vue.use(configId);

Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
var that = this
router.beforeEach((to, from, next) => {
	var user =  sessionStorage.getItem("user")
    if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
            if (user) { // 判断缓存里面是否有 userName  //在登录的时候设置它的值
                next();
//              console.log(user)
            } else {
            	MessageBox('您还没登录，请先登录！','温馨提示',{
					  confirmButtonText: '取消',
				      cancelButtonText: '登录',
				      showClose:false,
				      type: 'warning'
				}).then(() => {
						 router.push('/login')
					});
	            }
        } else {
            next();
        }
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
//判断token失效跳转
axios.interceptors.response.use(response => {
	var urls = 'http://www.pinuc.com/?r=login&redirect_url='+encodeURIComponent(location.href.split('#')[0]+'#'+location.href.split('#')[1])
	if(response) {
		 	// console.log(response)
		// if(response.data.code == -403) {
		// 	MessageBox('登录信息失效,请重新登录！','温馨提示',{
		// 			  confirmButtonText: '取消',
		// 		      cancelButtonText: '确定',
		// 			  showClose:false,
		// 			  closeOnClickModal:false,
		// 			  type: 'warning',
		// 		}).then(() => {
		// 				router.push('/login')
		// 		});
		// 		return
		// 		// router.push('/login')
			
		// }
	}
	return response;
}, error => {

	return Promise.reject(error.response) //返回接口返回的错误信息
})

new Vue({
	router,
	store,
//	VueAMap,
	render: h => h(index)

}).$mount('#app')